import React from 'react';
import { cn } from '../../lib/utils';
import { Card, CardContent } from './card';

function KpiCard({
  title,
  value,
  icon: Icon,
  iconColor,
  iconBgColor,
  trend,
  trendLabel,
  trendPositive,
  subtitle,
  className,
}) {
  return (
    <Card className={cn(className)}>
      <CardContent className="p-6">
        <div className="flex items-start justify-between gap-4">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium text-text-secondary">{title}</p>
            <p className="mt-2 text-3xl font-semibold tracking-tight text-text-primary">{value}</p>
            {subtitle ? (
              <p className="mt-1 text-sm text-text-tertiary">{subtitle}</p>
            ) : null}
            {trend && trendLabel ? (
              <p
                className={cn(
                  'mt-2 text-sm font-medium',
                  trendPositive ? 'text-success-600' : 'text-danger-500'
                )}
              >
                {trendLabel}
              </p>
            ) : null}
          </div>
          {Icon ? (
            <div
              className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md border border-border-light"
              style={{ backgroundColor: iconBgColor, color: iconColor }}
            >
              <Icon className="h-6 w-6" aria-hidden />
            </div>
          ) : null}
        </div>
      </CardContent>
    </Card>
  );
}

export { KpiCard };
